import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_859446c0: FaireBrandEntity = {
  token: "b_859446c0",
  type: "brand",
  name: "Jessica Matrasko Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/e83cce2fbe4cf6d98f4be080feda8528ea3e267d92a976afe3f032d156070eed.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1bbf61716705e15763526681ca87fdd4b5d85830487584e38d1b5028e8ab0c9a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e83cce2fbe4cf6d98f4be080feda8528ea3e267d92a976afe3f032d156070eed.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1bbf61716705e15763526681ca87fdd4b5d85830487584e38d1b5028e8ab0c9a.jpeg",
  location: "Los Angeles , CA, USA",
  minimumOrderDollars: 207,
  rating: 5,
  reviewCount: 97,
  isTopShop: true,
  isInsider: true,
  description:
    " Locally made in Los Angeles, with globally sourced materials since 2007.  Crafted using high quality gold filled materials and ethically sourced minerals. \n\nMy vibe: Inspired by Mom and Grandma's jewelry boxes; mix 1970's Elton John, David Bowie and Stevie Nicks with my 1980's youth (Lisa Frank rainbows foreveaaaaa) and you've got Jessica Matrasko Jewelry. It's me. It's you. It's taking your very favorite, wear 'em every day pieces and adding in new styles to create a look and style that is uniquely yours. ",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:35:48.887Z",
    importedBy: "entity-db-cli",
  },
};
